import { useEffect, useState } from "react";

let pushToastExternal = null;

export function toast(message, kind = "info") {
  if (pushToastExternal) pushToastExternal({ message, kind });
}

export default function ToastHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    pushToastExternal = ({ message, kind }) => {
      const id = crypto?.randomUUID?.() || String(Date.now() + Math.random());
      setItems((prev) => [...prev, { id, message, kind }]);
      setTimeout(() => {
        setItems((prev) => prev.filter((x) => x.id !== id));
      }, 3000);
    };

    return () => {
      pushToastExternal = null;
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="fixed inset-x-4 top-20 z-[9999] flex flex-col gap-2 sm:inset-x-auto sm:right-4 sm:top-4 sm:w-[320px]">
      {items.map((t) => (
        <div
          key={t.id}
          className={`rounded-xl px-4 py-3 text-sm shadow-lg ring-1 ring-black/10 ${
            t.kind === "error"
              ? "bg-red-500/90 text-white"
              : t.kind === "success"
              ? "bg-[#98dea3]/90 text-[#0b2b12]"
              : "bg-white/90 text-[#111827]"
          }`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
